import { create } from 'zustand'

import type { QueryStore } from '@models/Query'

import { initialState } from '../services/fetchTeBeoordelen'
import type { FetchTeBeoordelen } from '../types/FetchTeBeoordelen'

export { useTeBeoordelenStore }

const useTeBeoordelenStore = () => {
  const query = useStore((state) => state.query)
  const storeQuery = useStore((state) => state.storeQuery)

  return { query, storeQuery }
}

const useStore = create<QueryStore<FetchTeBeoordelen['query']>>((set) => ({
  query: initialState.query,
  storeQuery: (query) =>
    set((state) => ({ query: { ...state.query, ...query } })),
}))
